export default  [
  {
    key: "device_name",
    label: "Device",
  },
  {
    key: "geofence_name",
    label: "Geofence",
    sortable: true
  },

  {
    key: "owner_name",
    label: "Owner",
    sortable: true
  },

  {
    key: "contract_name",
    label: "Contract",
    sortable: true
  },

  {
    key: "on_time",
    label: "On Time",
    sortable: true
  },

  {
    key: "off_time",
    label: "OFF Time",
    sortable: true
  },

  {
    key: "pto_duration",
    label: "Duration",
    sortable: true
  },

  {
    key: "total_distance",
    label: "Distance",
    sortable: true
  },



]